'use client';

import { Fragment, useMemo } from 'react';
import katex from 'katex';
import { splitMathText } from '@jeraisonne/db/cards';

/**
 * Texte court avec formules `$…$` en ligne (titre de carte, d'exercice).
 * Contrairement à `MarkdownMath`, aucun markdown ni bloc : on rend un fragment
 * INLINE, à poser dans un <h1>, un <span>, un bouton… Le parent garde son style.
 * Une formule invalide reste affichée en source (jamais d'erreur rouge).
 */
export function MathText({ children, className }: { children: string; className?: string }) {
  const parts = useMemo(() => splitMathText(children ?? ''), [children]);
  const content = parts.map((part, i) => {
    if (part.kind === 'text') return <Fragment key={i}>{part.value}</Fragment>;
    let html: string | null = null;
    try {
      html = katex.renderToString(part.value, {
        displayMode: false,
        throwOnError: true,
        strict: 'ignore',
        trust: false,
        maxExpand: 1000,
      });
    } catch {
      html = null;
    }
    return html === null ? (
      <Fragment key={i}>{part.value}</Fragment>
    ) : (
      <span key={i} className="jr-math-text" dangerouslySetInnerHTML={{ __html: html }} />
    );
  });
  return className ? <span className={className}>{content}</span> : <>{content}</>;
}
